'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _indicator = require('./indicator');

var _indicator2 = _interopRequireDefault(_indicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.input.withConfig({
  componentId: 's1gus18t-0'
})(['position:absolute;overflow:hidden;margin:0;padding:0;border:0;outline:0;opacity:0;&:focus{& + ', '{box-shadow:0 0 2px 3px ', ';}}&:checked{& + ', '{position:relative;&::before{content:\'\';position:absolute;top:25%;left:25%;width:50%;height:50%;background-color:', ';border-radius:50%;}}}'], _indicator2.default, function (p) {
  return p.theme.focusColor;
}, _indicator2.default, function (p) {
  return p.theme.checkedColor;
});